import { render } from "./VendorFloatingNav.vue?vue&type=template&id=45b42297&scoped=true"
import script from "./VendorFloatingNav.vue?vue&type=script&lang=js"
export * from "./VendorFloatingNav.vue?vue&type=script&lang=js"

import "./VendorFloatingNav.vue?vue&type=style&index=0&id=45b42297&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b42297"]])

export default __exports__